module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step6_endcard.7c217d23.webp";